// 来源管理
import { createAPI } from '@common'

export default {
  // 新建/修改来源
  postSources: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20tpvsdft',
        'POST',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20tpvsdft', 'POST', { data: config.data }, null)
    }
  },
  // 来源详情
  getSources: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20tpvsdft',
        'GET',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20tpvsdft', 'GET', { params: config.params }, null)
    }
  },
  // 删除来源
  deleteSources: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20tpvsdft',
        'DELETE',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20tpvsdft', 'DELETE', { params: config.params }, null)
    }
  }
}
